import React from "react";
import { Link } from "react-router-dom";

const Products = ({ products, setProducts, handleClick }) => {
  // Define an array of sample product data
  const sampleProducts = [
    {
      id: 1,
      name: "pen I",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTD0kT_bjYBCgh5G-ExyjFEp9zGTbnaYQmn3w&usqp=CAU",
      price: 15.00,
    },
    {
      id: 2,
      name: "pen II",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTD0kT_bjYBCgh5G-ExyjFEp9zGTbnaYQmn3w&usqp=CAU",
      price: 15.00,
    },
    {
      id: 3,
      name: "pen III",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTD0kT_bjYBCgh5G-ExyjFEp9zGTbnaYQmn3w&usqp=CAU",
      price: 15.00,
    },
    {
        id: 4,
        name: "pen IV",
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTD0kT_bjYBCgh5G-ExyjFEp9zGTbnaYQmn3w&usqp=CAU",
        price: 15.00,
    },
    {
        id: 5,
        name: "pen V",
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTD0kT_bjYBCgh5G-ExyjFEp9zGTbnaYQmn3w&usqp=CAU",
        price: 15.00,
    },
    {
        id: 6,
        name: "pen VI",
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTD0kT_bjYBCgh5G-ExyjFEp9zGTbnaYQmn3w&usqp=CAU",
        price: 15.00,
    },
    {
        id: 7,
        name: "pen VII",
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTD0kT_bjYBCgh5G-ExyjFEp9zGTbnaYQmn3w&usqp=CAU",
        price: 15.00,
    },
    {
        id: 8,
        name: "pen VIII",
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTD0kT_bjYBCgh5G-ExyjFEp9zGTbnaYQmn3w&usqp=CAU",
        price: 15.00,
    },
    {
        id: 9,
        name: "pen IX",
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTD0kT_bjYBCgh5G-ExyjFEp9zGTbnaYQmn3w&usqp=CAU",
        price: 15.00,
    },
    {
        id: 10,
        name: "pen X",
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTD0kT_bjYBCgh5G-ExyjFEp9zGTbnaYQmn3w&usqp=CAU",
        price: 15.00,
    },
    {
        id: 11,
        name: "pen XI",
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTD0kT_bjYBCgh5G-ExyjFEp9zGTbnaYQmn3w&usqp=CAU",
        price: 15.00,
    },
    {
        id: 12,
        name: "pen XII",
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTD0kT_bjYBCgh5G-ExyjFEp9zGTbnaYQmn3w&usqp=CAU",
        price: 15.00,
    },
    {
        id: 13,
        name: "pen XIII",
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTD0kT_bjYBCgh5G-ExyjFEp9zGTbnaYQmn3w&usqp=CAU",
        price: 15.00,
    },
    {
        id: 14,
        name: "pen XIV",
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTD0kT_bjYBCgh5G-ExyjFEp9zGTbnaYQmn3w&usqp=CAU",
        price: 15.00,
    },
    {
        id: 15,
        name: "pen XV",
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTD0kT_bjYBCgh5G-ExyjFEp9zGTbnaYQmn3w&usqp=CAU",
        price: 15.00,
    },

    // Add more products here...
  ];

  // Combine the sample product data with the actual product data
  const allProducts = [...sampleProducts];

  return (
    <>
    <div className="products">
        <h1>Our Products</h1>
      <div className="all-products-container">
        <div className="product-grid">
          {allProducts.map((product) => {
            return (
              <div key={product.id} className="product-card">
                <Link
                  to={`/products/${product.id}`}
                  className="singleProduct"
                  key={product.id}
                >
                  <img
                    src={product.image}
                    className="product-image"
                    alt={product.name}
                  />
                  <div className="product-info">
                    <h5 className="product-title">{product.name}</h5>
                    <p className="product-price">${product.price}</p>
                  </div>
                </Link>
                <button
                  onClick={() => handleClick(product)}
                  className="addCartBtn"
                >
                  Add To Your Cart
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </div>
    </>
  );
};

export default Products;